module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "order-load"
  }, [(_vm.orderData.status_buttons) ? _c('div', {
    staticClass: "load-left"
  }, [(_vm.orderData.status_buttons.icon) ? _c('img', {
    staticClass: "load-img",
    attrs: {
      "src": 'https://static.dierqudao.com/images/icon-order-' +
        _vm.orderData.status_buttons.icon +
        '.png',
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "load-detail"
  }, [_c('div', {
    staticClass: "order-load-title"
  }, [_vm._v("\n          " + _vm._s(_vm.orderData.status_buttons.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "order-load-det"
  }, [(_vm.lastTime) ? _c('van-count-down', {
    attrs: {
      "time": _vm.lastTime
    }
  }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.orderData.status_buttons.note) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "order-button"
  }, [(_vm.orderData.status_buttons.name == '待发货') ? _c('div', {
    staticClass: "header-btn success-btn",
    on: {
      "click": _vm.toSend
    }
  }, [_vm._v("\n            催发货\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orderData.status_buttons.buttons), function(button, index) {
    return _c('div', {
      class: 'header-btn ' + button.class + '-btn',
      on: {
        "click": function($event) {
          return _vm.orderDo(button.type)
        }
      }
    }, [_vm._v("\n            " + _vm._s(button.name) + "\n          ")])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "scene": "goods",
      "show": _vm.payShow,
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  }), _vm._v(" "), _c('BookDialog', {
    attrs: {
      "show": _vm.bookDialogShow,
      "wxNote": '订单' + _vm.orderData.code + '，' + _vm.book.note,
      "wxCode": _vm.book.wxcode,
      "wxPic": _vm.book.pic_url,
      "phone": _vm.book.phone
    },
    on: {
      "onBookCancle": _vm.onBookCancle
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66851a36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetailHeader.vue
// module id = 2458
// module chunks = 0